<template>
  <div class="mb-4" v-if="lessons.length>0">
    <v-row align="center" dense>
      <v-col>
        <h2 class="body-1">Неоплаченные занятия</h2>
      </v-col>
      <v-col align="right">
        <v-btn text
               :to="'lessons?payed=debt&date1='+earlyDate+'&date2='+today"
               color="accent">Смотреть все</v-btn>
      </v-col>
    </v-row>
    <v-divider class="mb-1"></v-divider>

    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <v-layout column v-if="!loading">
      <v-flex v-for="lesson of lessons" :key="lesson.id" class="mb-2">
        <user-lesson-card :lesson="lesson" :show-date="true"></user-lesson-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import Lesson from '../../api/Lesson';
import UserLessonCard from './UserLessonCard.vue';

export default {
  name: 'UserDebtLessons',
  components: { UserLessonCard },
  data: () => ({
    earlyDate: moment().subtract(1, 'year').format('YYYY-MM-DD'),
    today: moment().format('YYYY-MM-DD'),
    lessons: [],
    loading: false,
  }),
  computed: {
    currentUserId() {
      return this.currentUser.id;
    },
    ...mapGetters(['currentUser']),
  },
  watch: {
    currentUserId() {
      this.loadLessons();
    },
  },
  methods: {
    async loadLessons() {
      if (this.currentUser) {
        this.loading = true;
        const filter = {
          userId: this.currentUser.id,
          scopeUserId: this.currentUser.id,
          date: [this.earlyDate, this.today],
          includeRecords: true,
          includeTasksLimited: true,
          includeMarks: true,
          includeParams: true,
          includeComments: true,
          includeTaskAnswers: true,
          debt: true,
          sort: 'date',
        };
        const result = await Lesson.fetch(filter);
        this.lessons = result.data.lessons;
        this.loading = false;
      }
    },
  },
  mounted() {
    this.loadLessons();
  },
};
</script>

<style scoped>

</style>
